import { DeviceApi } from "@/modules/device/types/device.type";
import { RoomApi } from "@/modules/rooms/types/room.type";
import type { MeetingLayout } from '../utils/layout';
export interface CreateMeetingPayload {
  remindHostToJoin?: boolean;
  allowScreenShare?: boolean;
  layout?: MeetingLayout;
  autoLayoutByMic?: boolean;
  title: string;
  description?: string;
  roomMeetingId?: string;

  startTime: string; // ISO 8601 format
  endTime: string;   // ISO 8601 format
  duration?: number; // minutes

  participantEmails?: string[];
  participantRoles?: ("host" | "co_host" | "participant")[];
  deviceIds?: string[];

  allowRecording?: boolean;
  autoRecord?: boolean;
  defaultMicOn?: boolean;
  defaultCameraOn?: boolean;

  cameraResolution?: "720p" | "1080p" | "4K";

  waitingRoomEnable?: boolean;
  requirePassword?: boolean;
  password?: string;

  maxParticipants?: number;

  notes?: string;
  reminderMinutes?: number;

  isRecurring?: boolean;
  recurrencePattern?: "daily" | "weekly" | "monthly" | "custom";
  recurrenceDays?: number[]; // 0-6 (Sun-Sat)
  recurrenceEndDate?: string; // ISO 8601
  type?: "scheduled" | "instant";
  lockAction?: boolean;
  focusParticipant?: string;
  mainType?: "camera" | "screen_share";
}

export interface Meeting {
  focusParticipant?: string;
  mainType?: "camera" | "screen_share" | "CAM" | "SCREEN";
  remindHostToJoin?: boolean;
  allowScreenShare?: boolean;
  layout?: MeetingLayout;
  autoLayoutByMic?: boolean;
  id: string;
  title: string;
  description: string;
  meetingCode: string;
  meetingLink: string | null;
  roomMeetingId: string;
  roomMeetingName: string;
  startTime: string;
  endTime: string;
  duration: number;
  status: string;
  allowRecording: boolean;
  autoRecord: boolean;
  defaultMicOn: boolean;
  defaultCameraOn: boolean;
  cameraResolution: string;
  maxParticipants: number;
  notes: string;
  reminderSent: boolean;
  reminderMinutes: number;
  isRecurring: boolean;
  recurrencePattern: string;
  recurrenceDays: number[];
  recurrenceEndDate: string;
  parentMeetingId: string | null;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  createdByName: string;
  updatedBy: string;
  participants: MeetingParticipant[];
  devices: MeetingDevice[];
  lockAction?: boolean;
  linkStream?: string[];
  recordings?: RecordingInfo[];
  roomMeeting?: RoomApi;
}
 

export interface MeetingDevice {
  microphoneVolume?: number;
  id: string;
  deviceId: string;
  deviceName: string;
  imei: string;
  connectionStatus: string;
  leftAt?: string | null;
}

export interface MeetingParticipant {
  id: string;
  userId: string;
  deviceImei: string | null;
  metadata: {
    userId: string | null;
  };
  identity: string;
  email: string;
  fullName: string;
  name: string;
  role: string;
  joinedAt: string | null;
  leftAt: string | null;
  canPublish: boolean;
  canSubscribe: boolean;
  micMuted?: boolean;
  cameraMuted?: boolean;
  device: DeviceApi;
  isRaiseHand?: boolean;
  isCoHost?: boolean;
  canShared?: boolean;
}

export interface MeetingStatistics {
  total: number;
  scheduled: number;
  inProgress: number;
  completed: number;
  cancelled: number;
}
export interface MeetingFilter {
  page?: number;
  pageSize?: number;
  status?: MeetingStatus;
  search?: string;
  roomMeetingId?: string;
  startDate?: string;
  endDate?: string;
}
export enum MeetingStatus {
  ALL = "all",
  SCHEDULED = "scheduled",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
  PREPARED = "prepared",
}
export interface RecordingInfo {
  id: string;
  egressId: string;
  fileName: string;
  s3Key: string;
  s3Bucket: string;
  s3Url: string;
  fileSize: number | null;
  duration: number | null;
  status: string;
  layout: string;
  audioOnly: boolean;
  errorMessage: string | null;
  startedAt: string;
  endedAt: string | null;
  createdBy: string;
}

export interface StreamInfo {
  egressId: string;
  startedAt?: string;
  endedAt?: string;
  status?: string;
  layout?: string;
  streamUrls?: string[];
}